import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7fb3d0a0")

_pushScopeId("data-v-7fb3d0a0")
const _hoisted_1 = { class: "full-container" }
const _hoisted_2 = { class: "header-menu-container align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "width40px" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "width60px" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "width60px" }, null, -1)
const _hoisted_7 = { class: "body-container" }
const _hoisted_8 = { class: "vertical-menu-container" }
const _hoisted_9 = { class: "flex1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_select_list = _resolveComponent("select-list")
  const _component_text_popover = _resolveComponent("text-popover")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_horizontal = _resolveComponent("horizontal")
  const _component_vertical = _resolveComponent("vertical")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_password_dialog = _resolveComponent("password-dialog")
  const _component_billing_dialog = _resolveComponent("billing-dialog")
  const _component_link_site_dialog = _resolveComponent("link-site-dialog")
  const _component_link_succeed_dialog = _resolveComponent("link-succeed-dialog")
  const _component_document_dialog = _resolveComponent("document-dialog")
  const _component_import_face_tip = _resolveComponent("import-face-tip")
  const _component_emergency_action_dialog = _resolveComponent("emergency-action-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_horizontal, {
      onLogOut: _ctx.goBackLogin,
      "home-url": `/${_ctx.propertyBaseRouter}/${_ctx.propertySubRouter.home}`
    }, {
      default: _withId(() => [
        _createVNode("header", _hoisted_2, [
          _hoisted_3,
          (_ctx.community.ProjectType.value==='community'&&_ctx.community.isNew.value)
            ? (_openBlock(), _createBlock(_component_cus_button, {
                key: 0,
                onClick: _ctx.openEmergencyAction
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.EmergencyAction), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _hoisted_4,
          _createVNode(_component_text_popover, {
            name: _ctx.activeCommunity.label,
            isShow: _ctx.controlPopVal['community'],
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'community')))
          }, {
            default: _withId(() => [
              _createVNode(_component_select_list, {
                list: _ctx.communityList,
                active: _ctx.activeCommunity.ID,
                onChange: _ctx.changeCommunity
              }, null, 8, ["list", "active", "onChange"])
            ]),
            _: 1
          }, 8, ["name", "isShow"]),
          _hoisted_5,
          _createVNode(_component_text_popover, {
            name: _ctx.account,
            isShow: _ctx.controlPopVal['account'],
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'account')))
          }, {
            default: _withId(() => [
              _createVNode(_component_select_list, {
                list: _ctx.userOperaList,
                onChange: _ctx.chooseOpera
              }, null, 8, ["list", "onChange"])
            ]),
            _: 1
          }, 8, ["name", "isShow"]),
          _hoisted_6,
          (_ctx.community.ProjectType.value==='community'&&_ctx.community.isNew.value)
            ? (_openBlock(), _createBlock(_component_el_badge, {
                key: 1,
                class: "badge-number",
                value: _ctx.community.alertCount.value,
                hidden: _ctx.community.alertCount.value===0,
                type: "danger"
              }, {
                default: _withId(() => [
                  _createVNode("i", {
                    class: "el-icon-my-miaoshatixing_icon alarm-icon",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toAlarm && _ctx.toAlarm(...args)))
                  })
                ]),
                _: 1
              }, 8, ["value", "hidden"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onLogOut", "home-url"]),
    _createVNode("section", _hoisted_7, [
      _createVNode("aside", _hoisted_8, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withId(() => [
            _createVNode(_component_vertical, { menus: _ctx.menus }, null, 8, ["menus"])
          ]),
          _: 1
        })
      ]),
      _createVNode("section", _hoisted_9, [
        _createVNode(_component_router_view, {
          key: _ctx.$route.fullPath
        })
      ])
    ]),
    (_ctx.isShowPasswordDialog)
      ? (_openBlock(), _createBlock(_component_password_dialog, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowPasswordDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowBillingDialog)
      ? (_openBlock(), _createBlock(_component_billing_dialog, {
          key: 1,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowBillingDialog = false)),
          userType: "property"
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowLinkSiteDialog)
      ? (_openBlock(), _createBlock(_component_link_site_dialog, {
          key: 2,
          onSuccess: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowLinkSucceedDialog = true)),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowLinkSiteDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowLinkSucceedDialog)
      ? (_openBlock(), _createBlock(_component_link_succeed_dialog, {
          key: 3,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowLinkSucceedDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowDocumentDialog)
      ? (_openBlock(), _createBlock(_component_document_dialog, {
          key: 4,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowDocumentDialog = false)),
          list: _ctx.fileList
        }, null, 8, ["list"]))
      : _createCommentVNode("", true),
    (_ctx.isShowImportFaceTip)
      ? (_openBlock(), _createBlock(_component_import_face_tip, {
          key: 5,
          "face-task-list": _ctx.dealImportDetails,
          onClose: _ctx.closeImportFaceTip
        }, null, 8, ["face-task-list", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_emergency_action_dialog, { ref: "emergencyActionDialogRef" }, null, 512)
  ]))
})